import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { IThreeDCategoryListItem } from '@types';
import { useQuery } from '@tanstack/react-query';

async function getThreeDCategoryList(): Promise<AxiosResponse<FetchResult<IThreeDCategoryListItem[]>>> {
  const response = await instance.get(`/assets-3d/categories`);
  return response;
}

interface UseFetchThreeDCategoryListCallbacks {
  onSuccess?: (data: AxiosResponse<FetchResult<IThreeDCategoryListItem[]>>) => void;
}

const useFetchThreeDCategoryList = (callbacks?: UseFetchThreeDCategoryListCallbacks) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/assets-3d/categories`],
    queryFn: async () => {
      const response = await getThreeDCategoryList();

      // 데이터 페치 성공 시 콜백 실행
      if (callbacks?.onSuccess) {
        callbacks.onSuccess(response);
      }

      return response;
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchThreeDCategoryList;
